import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'checkAllow',
    pure: false
})
export class PipeCheckAllow implements PipeTransform {
    transform(allows: any, check: any, list:any = false): any {
        let allow = false;
        if(list){
            list.map(item => {
                if(this.check(item[check], allows))
                    allow = true;
            });
        } else if (check instanceof Object) {
            allow = this.check(check, allows);
        }
        return allow;
    }

    check(check, allows){
        let allow = false;

        Object.entries(check).forEach(([k, b]: any) => {
            var a = allows[k];
            if (typeof a == 'undefined')
                return false;

            allow = !!a.filter(item => b.indexOf(item?.id) > -1).length;
        });

        return allow;
    }
}